import { render, staticRenderFns } from "./VirtualContractEntity.vue?vue&type=template&id=1cdcdc94&"
import script from "./VirtualContractEntity.vue?vue&type=script&lang=js&"
export * from "./VirtualContractEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cdcdc94')) {
      api.createRecord('1cdcdc94', component.options)
    } else {
      api.reload('1cdcdc94', component.options)
    }
    module.hot.accept("./VirtualContractEntity.vue?vue&type=template&id=1cdcdc94&", function () {
      api.rerender('1cdcdc94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VirtualContractEntity.vue"
export default component.exports